import { call, put } from 'redux-saga/effects';
import { Types, ManifestationDataProps } from './types';
import {
  loadManifestationsSuccess,
  loadManifestationsFailure
} from './actions';
import { addToast } from '../toast/actions';
import { EToastTypes } from '../toast/types';
import { Manifestation } from '../../../services/Manifestation';

interface ILoadManifestationsParams {
  payload: {
    customerId: string;
  };
  type: Types;
}

export function* loadManifestationsSaga(params: ILoadManifestationsParams) {
  const { customerId } = params.payload;
  try {
    const manifestationService = new Manifestation();
    const manifestations: ManifestationDataProps[] = yield call(
      manifestationService.getManifestation.bind(manifestationService),
      customerId
    );
    yield put(loadManifestationsSuccess(manifestations));
  } catch (err) {
    console.error('loadManifestations', err);
    yield put(
      addToast({
        message: 'Falha ao carregar as manifestações.',
        type: EToastTypes.DANGER,
        durationInMS: 5000
      })
    );
    yield put(loadManifestationsFailure(err));
  }
}
